module.exports = __webpack_public_path__ + "img/logoText.7ac731c6.svg";